import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useParams, useNavigate } from "react-router-dom";
import { ResetPassword } from "../utils/usersAPI";

const ResetPasswordPage = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const passwordFieldSx = {
    direction: "rtl",
    "& label": {
      right: 30,
      left: "auto",
      transformOrigin: "top right",
    },
    "& legend": {
      textAlign: "right",
    },
    "& input": {
      textAlign: "right",
      paddingRight: "14px",
      paddingLeft: "45px",
    },
  };

  const handleReset = async () => {
    setError("");
    setMessage("");

    if (!newPassword || !confirmPassword) {
      setError("חובה למלא את כל השדות");
      return;
    }

    if (newPassword.length < 6) {
      setError("הסיסמה חייבת להכיל לפחות 6 תווים");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("הסיסמאות אינן תואמות");
      return;
    }

    try {
      const res = await ResetPassword(token, newPassword);
      setMessage(res.data);

      setTimeout(() => {
        navigate("/signIn");
      }, 1500);
    } catch (err) {
      setError(err.response?.data || "אירעה שגיאה באיפוס הסיסמה");
    }
  };

  return (
    <Container maxWidth="xs" style={{ marginTop: "140px" }}>
      <Typography variant="h4" align="center" gutterBottom>
        איפוס סיסמה
      </Typography>

      <TextField
        label="סיסמה חדשה"
        type={showNewPassword ? "text" : "password"}
        fullWidth
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        sx={passwordFieldSx}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowNewPassword(!showNewPassword)}
                edge="end"
              >
                {showNewPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <br />
      <br />

      <TextField
        label="אימות סיסמה"
        type={showConfirmPassword ? "text" : "password"}
        fullWidth
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        sx={passwordFieldSx}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                edge="end"
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <br />
      <br />

      <Button variant="contained" fullWidth onClick={handleReset}>
        עדכון סיסמה
      </Button>

      {message && <Typography color="green">{message}</Typography>}
      {error && <Typography color="error">{error}</Typography>}
    </Container>
  );
};

export default ResetPasswordPage;